import InterviewList, { Columns, OrderValue } from 'components/Interview/List';
import ProfileNavigationHead from 'components/profileNavigation/Head';
import React, { FC, useCallback, useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { setOrder, setPage } from 'store/actions/mentor/interviewLists';
import { StoreState } from 'store/reducers';
import useSWR from 'swr';
import Interview from 'types/Interview';
import { Action } from 'types/typeguards/reducerActions';
import { MenteeDetailsContext } from '..';

export const activeColumns: Columns = {
  date: true,
  hour: true,
  status: true,
  menteeName: true,
  type: true,
  viewDetails: true,
};

type RetrievedData = {
  interviews: Interview[] | undefined;
  count: number | undefined;
  pages: number | undefined;
};

type Props = {
  page: number;
  setPage: (page: number) => void;
  order: OrderValue;
  setOrder: (order: OrderValue) => void;
};
const Interviews: FC<Props> = ({ page, setPage, order, setOrder }) => {
  const { id } = useParams();
  const { data } = useSWR<RetrievedData>(
    `/interview/mentorship/${id}?page=${page}&order=${order}`,
  );

  const [retrievedData, setRetrievedData] = useState<RetrievedData>({
    interviews: undefined,
    count: undefined,
    pages: undefined,
  });
  useEffect(() => {
    if (data) {
      setRetrievedData(data);
    }
  }, [data]);

  // Reset page to 0 if the stored page is out of range
  useEffect(() => {
    if (data?.pages && data?.pages <= page) {
      setPage(0);
    }
  }, [data, page, setPage]);

  const location = useLocation();
  const getLink = useCallback(
    (id: number): string => {
      return `/mentor/mentorship/management/interviews/${id}/?from=${location.pathname}`;
    },
    [location],
  );

  const { mentee } = useContext(MenteeDetailsContext);

  return (
    <>
      <ProfileNavigationHead
        title="Liste d'entretiens"
        subtitle={`La liste de vos entretiens programmés avec ${
          mentee?.firstName || 'ce mentoré'
        }`}
      />
      <InterviewList
        interviews={retrievedData.interviews}
        {...{
          activeColumns,
          getLink,
          page,
          setPage,
          order,
          setOrder,
        }}
        pages={retrievedData.pages}
        variant="mentor"
        loading={!data}
      />
    </>
  );
};

const mapStateToProps = (state: StoreState) => {
  return {
    page: state.mentor.interviewLists.mentee.page,
    order: state.mentor.interviewLists.mentee.order,
  };
};

const mapDispatchToProps = (dispatch: (action: Action) => void) => {
  return {
    setPage: (page: number) => dispatch(setPage('mentee', page)),
    setOrder: (order: OrderValue) => dispatch(setOrder('mentee', order)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Interviews);
